import type {
    IAddTechClassification, 
    IClassOptionResData, 
    IEditProjectInfoApply, 
    IEditProjectInfoApprParam, 
    IKeyRoadMap, 
    IKeyRoadMapQuery, 
    IKeyRoadMapResData, 
    IListRes, 
    ILogQuery, 
    IOptionQueryPayload,
    IClassification,
    IProjectInfo, 
    IProjectInfoQuery, 
    IProjectInfoResData, 
    IWorkgroupResData
} from '@/store/models/tableEdit.model'
import request, { requestFile } from '@/utils/request'

// 获取下拉列表 某一类选项
export const getDicOfClass = (data: IOptionQueryPayload): Promise<IClassOptionResData[]> => request<IClassOptionResData[]>({
    method: 'GET',
    url: '/api/das/management/dictionary',
    params: data
})

// workgroup
export const getWorkgroup = (): Promise<IWorkgroupResData> => request<IWorkgroupResData>({
    method: 'GET',
    url: '/api/pangooITMT/workgroup'
})
export const addWorkgroup = (groupName: string, ptnHeader: string): Promise<IListRes> => request<IListRes>({
    method: 'POST',
    url: '/api/pangooITMT/workgroup',
    params: {
        groupName,
        ptnHeader
    }
})
export const editWorkgroup = (id: string, groupName: string): Promise<IListRes> => request<IListRes>({
    method: 'PUT',
    url: `/api/pangooITMT/workgroup/${id}`,
    params: {
        groupName
    }
})
export const delWorkgroup = (id: number): Promise<IListRes> => request<IListRes>({
    method: 'DELETE',
    url: `/api/pangooITMT/workgroup/${id}`
})

// roadmap
export const getRoadMapList = (param: IKeyRoadMapQuery | number): Promise<IListRes> => request<IListRes>({
    method: 'GET',
    url: '/api/pangooITMT/keyRoadMap',
    params: {
        workGroupId: typeof param === 'number' ? param : param?.workGroupId,
        pageNo: typeof param === 'number' ? undefined : param?.pageNo,
        pageSize: typeof param === 'number' ? undefined : param?.pageSize
    }
})
export const getRoadMapById = (id: number): Promise<IKeyRoadMapResData> => request({
    method: 'GET',
    url: `/api/pangooITMT/keyRoadMap/${id}`,
})
export const addRoadMap = (data: IKeyRoadMap): Promise<number> => request({
    method: 'POST',
    url: '/api/pangooITMT/keyRoadMap',
    data
})
export const editRoadMap = (data: IKeyRoadMap): Promise<void> => request({
    method: 'PUT',
    url: `/api/pangooITMT/keyRoadMap/${data.id}`,
    data
})
export const delRoadMap = (id: number): Promise<void> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/keyRoadMap/${id}`,
})
// table2 Classification
export const getTechClassificationList = (param: IKeyRoadMapQuery | number): Promise<IListRes> => request<IListRes>({
    method: 'GET',
    url: '/api/pangooITMT/techClassification',
    params: {
        workGroupId: typeof param === 'number' ? param : param?.workGroupId,
        pageNo: typeof param === 'number' ? undefined : param?.pageNo,
        pageSize: typeof param === 'number' ? undefined : param?.pageSize
    }
})
export const getTechClassificationListAll = (workGroupId: number): Promise<IClassification[]> => request<IClassification[]>({
    method: 'GET',
    url: '/api/pangooITMT/techClassification/all',
    params: {
        workGroupId
    }
})
export const addTechClassification = (data: IAddTechClassification): Promise<void> => request({
    method: 'POST',
    url: '/api/pangooITMT/techClassification',
    data
})
export const editTechClassification = (data: IAddTechClassification): Promise<void> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techClassification/${data.id}`,
    data
})
export const delTechClassification = (id: number): Promise<void> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/techClassification/${id}`,
})
// project info
export const getProjectInfoList = (param: IProjectInfoQuery | undefined): Promise<IListRes> => request<IListRes>({
    method: 'GET',
    url: '/api/pangooITMT/techProjectInfo',
    params: {
        techClassId: param ? (param?.techClassId instanceof Array ? param?.techClassId?.join(',') : undefined) : undefined,
        pageNo: typeof param === 'number' ? undefined : param?.pageNo,
        pageSize: typeof param === 'number' ? undefined : param?.pageSize,
        workGroupId: param ? (param.workGroupId instanceof Array ? param.workGroupId.join(',')  : param.workGroupId) : undefined,
        buStakeholder: param ? ((typeof param !== 'number') ? param.buStakeholder : undefined) : undefined,
        techLevel: param ? ((param.techLevel instanceof Array) ? param.techLevel.join(',') : undefined) : undefined,
        description: param ? ((typeof param !== 'number') ? param.description : undefined) : undefined,
        developedBy: param ? ((typeof param !== 'number') ? param.developedBy : undefined) : undefined,
        isAll: param ? ((typeof param !== 'number') ? param.isAll : false) : false,
        maturity: param ? ((param.maturity instanceof Array) ? param.maturity.join(',') : undefined) : undefined,
        deliveryReview: param ? ((param.deliveryReview instanceof Array) ? param.deliveryReview.join(',') : undefined) : undefined,
        maxResourceNeeded: param ? ((typeof param !== 'number') ? param.maxResourceNeeded : undefined) : undefined,
        minResourceNeeded: param ? ((typeof param !== 'number') ? param.minResourceNeeded : undefined) : undefined,
        priority: param ? ((param.priority instanceof Array) ? param.priority.join(',') : undefined) : undefined,
        quantitativeIndicators: param ? ((typeof param !== 'number') ? param.quantitativeIndicators : undefined) : undefined,
        requirementSource: param ? ((param.requirementSource instanceof Array) ? param.requirementSource.join(',')  : undefined) : undefined,
        researchForms: param ? ((param.researchForms instanceof Array) ? param.researchForms.join(',')  : undefined) : undefined,
        subsidiary: param ? ((typeof param !== 'number') ? param.subsidiary : undefined) : undefined,
        techName: param ? ((typeof param !== 'number') ? param.techName : undefined) : undefined,
        techPtn: param ? ((typeof param !== 'number') ? param.techPtn : undefined) : undefined,
        tMTApproval: param ? ((param.tMTApproval instanceof Array) ? param.tMTApproval.join(',')  : undefined) : undefined,
        relevanceBuss: param ? ((param.relevanceBuss instanceof Array) ? param.relevanceBuss?.join(',')  : undefined) : undefined,
        toolsEquipment: param ? ((typeof param !== 'number') ? param.toolsEquipment : undefined) : undefined,
        planBudgeting: param ? ((typeof param !== 'number') ? param.planBudgeting : undefined) : undefined,
        humanBudgeting: param ? ((typeof param !== 'number') ? param.humanBudgeting : undefined) : undefined,
        budgeting: param ? ((typeof param !== 'number') ? param.budgeting : undefined) : undefined,
        platforms: param ? ((param.platformIds instanceof Array) ? param.platformIds.join(',') : undefined) : undefined,
        dutyBuss: param ? ((param.dutyBuss instanceof Array) ? param.dutyBuss.join(',') : undefined) : undefined,
        year: param ? ((param.year instanceof Array) ? param.year.join(',') : undefined) : undefined,
        status: param?.status,
        isMajorProject: param?.isMajorProject
    }
})
export const getProjectInfoById = (id: number): Promise<IProjectInfoResData> => request({
    method: 'GET',
    url: `/api/pangooITMT/techProjectInfo/${id}`,
})
export const addProjectInfo = (data: IProjectInfo): Promise<void> => request({
    method: 'POST',
    url: '/api/pangooITMT/techProjectInfo',
    data
})
export const editProjectInfo = (data: IProjectInfo): Promise<void> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techProjectInfo/${data.id}`,
    data
})
// 变更申请
export const editProjectInfoApply = (data: IEditProjectInfoApply): Promise<void> => request({
    method: 'POST',
    url: '/api/pangooITMT/techProjectInfo/change',
    data
})
// 获取变更申请列表
export const getProjectInfoApplyList = (params: IEditProjectInfoApprParam): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/techProjectInfo/change',
    params
})
// 变更申请审批
export const editProjectInfoAppr = (params: IEditProjectInfoApprParam, id: number| undefined): Promise<any> => request({
    method: 'POST',
    url: `/api/pangooITMT/techProjectInfo/change/audit/${id}`,
    data: params
})
export const delProjectInfo = (id: number): Promise<void> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/techProjectInfo/${id}`,
})
export const viewHistory = (params: ILogQuery): Promise<IListRes> => request({
    method: 'GET',
    url: '/api/pangooITMT/log',
    params
})
export const viewProjectHistory = (id: number,pageNo:number,pageSize:number): Promise<IListRes> => request({
    method: 'GET',
    url: `/api/pangooITMT/techProjectInfo/history/${id}`,
    params:{ pageNo:pageNo,pageSize:pageSize }
})

export const getAllProjectInfo = (): Promise<IProjectInfoResData[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/techProjectInfo/technicalShelf',
})
export const getAllTechnicalRoad = (): Promise<IProjectInfoResData[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/techProjectInfo/technicalRoad',
})
// eslint-disable-next-line
export const getAllTechnicalAnalysis = (param: any): Promise<IProjectInfoResData[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/techProjectInfo/technicalAnalysis',
    params:{
        ...param,
        techClassId: param ? (param?.techClassId instanceof Array ? param?.techClassId?.join(',') : undefined) : undefined,
        year: param ? ((param.year instanceof Array) ? param.year.join(',') : param.year) : undefined,
        researchForms: param ? ((param.researchForms instanceof Array) ? param.researchForms.join(',')  : undefined) : undefined,
        techLevel: param ? ((param.techLevel instanceof Array) ? param.techLevel.join(',') : undefined) : undefined,
        priority: param ? ((param.priority instanceof Array) ? param.priority.join(',') : undefined) : undefined,
        tMTApproval: param ? ((param.tmtapproval instanceof Array) ? param.tmtapproval.join(',')  : undefined) : undefined,
        maturity: param ? ((param.maturity instanceof Array) ? param.maturity.join(',') : undefined) : undefined,
        requirementSource: param ? ((param.requirementSource instanceof Array) ? param.requirementSource.join(',')  : undefined) : undefined,
        platforms: param ? ((param.platformIds instanceof Array) ? param.platformIds.join(',') : undefined) : undefined,
        relevanceBuss: param ? ((param.relevanceBuss instanceof Array) ? param.relevanceBuss.join(',') : undefined) : undefined,
        dutyBuss: param ? ((param.dutyBuss instanceof Array) ? param.dutyBuss.join(',') : undefined) : undefined,
    },
})
// eslint-disable-next-line
export const exportExcel = (params: any): Promise<{
    data: any
    type: string
    suffix: string
}> => requestFile({
    method: 'GET',
    url: '/api/pangooITMT/techProjectInfo/download',
    responseType: 'blob',
    params
})

// statistics
export const techTotal = (): Promise<any[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/statistics/techTotal'
})
export const allTech = (): Promise<{
    total: number
    workGroupName: string
    year: number
}[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/statistics/allTech'
})
export const priorities = (): Promise<{
    total: number
    priority: string
    workGroupName: string
}[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/statistics/priorities'
})
export const activities = (): Promise<any[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/statistics/activities'
})
export const keyTech = (): Promise<any[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/statistics/keyTech'
})
export const coreTech = (): Promise<any[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/statistics/coreTech'
})

// status
// 获取课题变更申请列表
export const getStatusList = (params: {
    approvalStatus?: 1 | 2 | 3 | 4 | 5 // 1待立项，2已立项，3结项待评审，4结项评审通过，5结项评审不通过
    auditStatus?: 1 | 2 | 3 // 1待审核，2审核通过，3审核不通过
    creator?: string
    pageNo?: number
    pageSize?: number
    taskStatus?: 1 | 2 | 3 // 1待审核，2审核通过，3审核不通过
}): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/techProject/status',
    params
})
// 添加课题状态申请
// eslint-disable-next-line
export const addChangeStatusApply = (data: any): Promise<any[]> => request({
    method: 'POST',
    url: '/api/pangooITMT/techProject/status',
    data
})
// 获取课题状态申请详情
export const getChangeStatusById = (id: string): Promise<any> => request({
    method: 'GET',
    url: `/api/pangooITMT/techProject/status/${id}`,
})
// 课题状态信息更新
// eslint-disable-next-line
export const editChangeStatusApply = (data: any): Promise<any[]> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techProject/status/${data.id}`,
    data
})
// 立项状态审核
// eslint-disable-next-line
export const changeStatusAppr = (data: any): Promise<any[]> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techProject/status/approval/${data.id}`,
    data
})
// 技术定义审核
// eslint-disable-next-line
export const changeStatusAudit = (data: any): Promise<any[]> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techProject/status/audit/${data.id}`,
    data
})
// 任务书审核
// eslint-disable-next-line
export const changeStatusTask = (data: any): Promise<any[]> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techProject/status/task/${data.id}`,
    data
})
// 获取所有课题关联项目信息
export const getTopic = (): Promise<any[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/techProject/status/topic',
})
// 添加课题关联项目
// eslint-disable-next-line
export const addTopic = (data: any): Promise<any[]> => request({
    method: 'POST',
    url: '/api/pangooITMT/techProject/status/topic',
    data
})
// 更新课题关联项目
// eslint-disable-next-line
export const editTopic = (data: any): Promise<any[]> => request({
    method: 'PUT',
    url: `/api/pangooITMT/techProject/status/topic/${data.id}`,
    data
})
// 获取项目列表
export const getProjectList = (params: {
    projectName: string
    projectCategory: string
    projectBu: string
    pageNo: number
    pageSize: number
}): Promise<any> => request({
    method: 'GET',
    url: '/api/cnt/systemSetting/projects',
    params
})
// 技术关联图谱
export const techRoadMap = (techProcessId: number): Promise<any> => request({
    method: 'GET',
    url: `/api/pangooITMT/techProjectInfo/techProcess/${techProcessId}`,
})
